import {
  ConfigurableGridFormViewComponentController,
  ToggleButtonDefinition,
} from "./controller";

export const vsServiceName = "configurableGridFormViewService";

export interface onToggleButtonChangedHandler {
  (
    toggleButton: ToggleButtonDefinition,
    controller: ConfigurableGridFormViewComponentController
  ): void;
}

export interface ConfigurableGridFormViewToggleButtonDefinition
  extends ToggleButtonDefinition {
  afterChanged?: onToggleButtonChangedHandler;
}

export class ConfigurableGridFormViewService {
  static $inject = <string[]>[];
  constructor() {}

  idDefaultQueryToggleButton(
    initiallyChecked: boolean
  ): ToggleButtonDefinition {
    return {
      id: "currentConfigurationTypeConfigurationsOnly",
      text: "Current Only",
      checked: initiallyChecked,
      onChanged: (
        toggleButton: ToggleButtonDefinition,
        controller: ConfigurableGridFormViewComponentController
      ) => {
        const { defaultQuery, selectedIds: ids } = controller.config;
        let effectiveIds = !ids?.length ? [0] : ids;
        defaultQuery.Ids = toggleButton.checked ? effectiveIds : undefined;
      },
    };
  }
}
